<div class="background">
  <div class="desktop-background">
    <div class="header">
      {{ 'money.withdrawButtonLabel' | translate }}
    </div>
    <div class="description">
      {{ 'money.withdrawDescription' | translate }}
    </div>
  </div>

  @if (preloader) {
    <libero-preload-spinner></libero-preload-spinner>
  } @else {
    @if (availableInvestments.length === 0) {
      <p data-cy="no-available-investments">
        {{ 'global.error.noAvailableInvestments' | translate }}
      </p>
    } @else if (availableBankAccounts.length === 0) {
      <p data-cy="no-available-bank-accounts">
        {{ 'global.error.noBankAccounts' | translate }}
      </p>
    } @else {
      <div class="form-layout" data-cy="money-withdraw-content">
        <div class="form-container">
          <div class="desktop-inputs-container">
            <div class="select-label">
              {{ 'money.fromSelectLabel' | translate }}
            </div>
            <div class="dropdown-container">
              <libero-money-dropdown-select
                [availableInvestments]="availableInvestments"
                [formName]="withdrawForm.controls['investmentId']"
                data-cy="money-dropdown-select-investments"
              ></libero-money-dropdown-select>
            </div>
          </div>
          <div class="arrow arrow--right"></div>
          <div class="arrow arrow--down"></div>
          <div class="desktop-inputs-container">
            <div class="select-label">
              {{ 'money.bankAccountsSelectLabel' | translate }}
            </div>
            <div class="dropdown-container">
              <libero-money-dropdown-select
                [availableBankAccounts]="availableBankAccounts"
                [formName]="withdrawForm.controls['clientBankAccountId']"
                data-cy="money-dropdown-select-bank-accounts"
              ></libero-money-dropdown-select>
            </div>
            <div class="select-label">
              {{ 'money.amount' | translate }}
            </div>
            <libero-money-amount-input
              [formName]="withdrawForm.controls['amount']"
              currency="Kč"
              [min]="selectedInvestmentMinWithdraw"
              [max]="selectedInvestmentMaxWithdraw"
              data-cy="withdraw-money-amount-input"
            ></libero-money-amount-input>
            <div
              class="withdraw-all"
              (click)="withdraw(true)"
              (keydown.space)="withdraw(true)"
              (keydown.enter)="withdraw(true)"
              tabindex="0"
              >
              {{ 'money.withdrawAllButtonLabel' | translate }}
            </div>
            <div class="buttons-container buttons-container--desktop">
              <div class="back-link" routerLink="/money" data-cy="route-back-from-withdraws">
                {{ 'global.buttons.back' | translate }}
              </div>
              <libero-button
                label="{{ 'money.withdrawButtonLabel' | translate }}"
                btnClasses="btn--primary btn--heading"
                (click)="withdraw()"
                data-cy="withdraw-money-button"
              ></libero-button>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="buttons-container buttons-container--phone">
      <libero-button
        label="{{ 'money.withdrawButtonLabel' | translate }}"
        btnClasses="btn--primary btn--heading"
        (click)="withdraw()"
      ></libero-button>
      <div class="back-link" routerLink="/money">
        {{ 'global.buttons.back' | translate }}
      </div>
    </div>
  }
</div>